export default __webpack_public_path__ + "static/media/publishers_hero.36ce7659.jpeg";